import React from 'react';
import { ShoppingBagIcon, LayersIcon, ArrowRightIcon } from 'lucide-react';
const Industries = () => {
  return <section className="py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-1885">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1886">
        <div className="text-center mb-16" data-id="element-1887">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1888">
            Built for Your Industry
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1889">
            Shopilots AI agents are designed to meet the unique needs of SaaS
            and E-commerce businesses
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1890">
          {/* E-commerce Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300" data-id="element-1891">
            <div className="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl w-16 h-16 flex items-center justify-center mb-6" data-id="element-1892">
              <ShoppingBagIcon className="h-8 w-8 text-white" data-id="element-1893" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1894">
              E-commerce
            </h3>

            <p className="text-gray-600 mb-6" data-id="element-1895">
              Transform your online store with AI shopping assistants that
              understand your products, guide customers, and drive conversions
              across all channels.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-1896">
              <li className="flex items-start" data-id="element-1897">
                <ArrowRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1898" />
                <span className="text-gray-700" data-id="element-1899">
                  Product recommendations based on customer preferences
                </span>
              </li>
              <li className="flex items-start" data-id="element-1900">
                <ArrowRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1901" />
                <span className="text-gray-700" data-id="element-1902">
                  24/7 customer support and order tracking
                </span>
              </li>
              <li className="flex items-start" data-id="element-1903">
                <ArrowRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1904" />
                <span className="text-gray-700" data-id="element-1905">
                  Cart abandonment recovery automation
                </span>
              </li>
              <li className="flex items-start" data-id="element-1906">
                <ArrowRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1907" />
                <span className="text-gray-700" data-id="element-1908">
                  Multi-channel deployment (website, social, messaging)
                </span>
              </li>
            </ul>

            <div className="pt-4 border-t border-gray-100" data-id="element-1909">
              <p className="text-sm text-gray-500 font-medium mb-2" data-id="element-1910">
                Perfect for:
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-1911">
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm font-medium" data-id="element-1912">
                  Retail
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm font-medium" data-id="element-1913">
                  Fashion
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm font-medium" data-id="element-1914">
                  Electronics
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm font-medium" data-id="element-1915">
                  Home & Garden
                </span>
              </div>
            </div>
          </div>

          {/* SaaS Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300" data-id="element-1916">
            <div className="bg-gradient-to-br from-indigo-500 to-blue-600 rounded-xl w-16 h-16 flex items-center justify-center mb-6" data-id="element-1917">
              <LayersIcon className="h-8 w-8 text-white" data-id="element-1918" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1919">
              SaaS Companies
            </h3>

            <p className="text-gray-600 mb-6" data-id="element-1920">
              Enhance your software platform with intelligent AI agents that
              onboard users, provide support, and increase product adoption at
              scale.
            </p>

            <ul className="space-y-3 mb-8" data-id="element-1921">
              <li className="flex items-start" data-id="element-1922">
                <ArrowRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1923" />
                <span className="text-gray-700" data-id="element-1924">
                  Interactive product demos and onboarding
                </span>
              </li>
              <li className="flex items-start" data-id="element-1925">
                <ArrowRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1926" />
                <span className="text-gray-700" data-id="element-1927">
                  Technical support and troubleshooting
                </span>
              </li>
              <li className="flex items-start" data-id="element-1928">
                <ArrowRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1929" />
                <span className="text-gray-700" data-id="element-1930">
                  Feature discovery and usage guidance
                </span>
              </li>
              <li className="flex items-start" data-id="element-1931">
                <ArrowRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5 mr-3" data-id="element-1932" />
                <span className="text-gray-700" data-id="element-1933">
                  Lead qualification and trial conversion
                </span>
              </li>
            </ul>

            <div className="pt-4 border-t border-gray-100" data-id="element-1934">
              <p className="text-sm text-gray-500 font-medium mb-2" data-id="element-1935">
                Perfect for:
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-1936">
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium" data-id="element-1937">
                  B2B SaaS
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium" data-id="element-1938">
                  Productivity Tools
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium" data-id="element-1939">
                  Analytics
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium" data-id="element-1940">
                  CRM
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-1941">
          <p className="text-gray-600 mb-6" data-id="element-1942">
            Ready to see how Shopilots can transform your business?
          </p>
          <a href="#signup" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-1943">
            Try It Free
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-1944" />
          </a>
        </div>
      </div>
    </section>;
};
export default Industries;